import i18n from './i18n';

// Languages that should render Right-To-Left
const RTL_LANGS = new Set(['ar', 'fa', 'he', 'ur']);

function applyDir(lang) {
  const base = (lang || '').split('-')[0];
  const dir = RTL_LANGS.has(base) ? 'rtl' : 'ltr';
  const html = document.documentElement;
  if (html.getAttribute('dir') !== dir) html.setAttribute('dir', dir);
  if (html.getAttribute('lang') !== base) html.setAttribute('lang', base);
}

// Initial apply
if (typeof document !== 'undefined') {
  applyDir(i18n.language);
}

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    applyDir(lng);
  }
});

export default applyDir;
